let globalRefetch: (() => void) | null = null;

/** Called from {@link ReadyForBillingPettyWorkCountProvider} only. */
export function setReadyForBillingPettyWorkCountRefetch(
  fn: (() => void) | null,
): void {
  globalRefetch = fn;
}

/**
 * Refetch ready-for-billing petty work count (sidebar badge). Call after any
 * lifecycle action that can move a petty work into or out of READY_FOR_BILLING.
 */
export function invalidateReadyForBillingPettyWorkCount(): void {
  globalRefetch?.();
}
